import Vue from 'vue';
import VueRouter from 'vue-router';
import ErrorPage from '../views/ErrorPage.vue';
import AccountDeletion from '../views/AccountDeletion.vue';

Vue.use(VueRouter);

const allowedApps = ['z-volt', 'charge-on', 'mazda', 'migrol', 'conneqtech', 'amag', 'volenergy'];

const routes = [
  {
    path: '/:appName',
    name: 'AccountDeletion',
    component: AccountDeletion,
    props: true,
    beforeEnter: (to, from, next) => {
      const { appName } = to.params;

      if (allowedApps.includes(appName)) {
        next();
      } else {
        next({
          name: 'ErrorPage',
          params: {
            errorMessage: '404 Not Found',
            errorDetails: 'The requested app is not supported.',
          },
        });
      }
    },
  },
  {
    path: '/error/:errorMessage/:errorDetails?',
    name: 'ErrorPage',
    component: ErrorPage,
    props: true,
  },
  {
    path: '*',
    redirect: () => {
      return {
        name: 'ErrorPage',
        params: { errorMessage: '404 Not Found', errorDetails: 'The requested page does not exist.' },
      };
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
